import React from 'react';
import { SvgProps } from 'react-native-svg';
import { ILLUSTRATIONS, IllustrationName, IllustrationVariant } from './registry';

type Props<N extends IllustrationName> = {
  name: N;
  variant?: IllustrationVariant<N> | (string & {});
  width?: number;
  height?: number;
  color?: string;
} & Omit<SvgProps, 'width' | 'height' | 'color'>;

export function Illustration<N extends IllustrationName>({
  name,
  variant,
  width = 50,
  height = 50,
  color,
  ...rest
}: Props<N>) {
  const entry = ILLUSTRATIONS[name];
  if (!entry) {
    console.warn(`[Illustration] Unknown illustration name: "${name}"`);
    return null;
  }
  const key = (variant ?? 'default') as keyof typeof entry;
  const Svg = (entry[key] ?? entry.default) as React.FC<SvgProps>;
  const colorProps = color ? { color, fill: color } : {};
  return <Svg width={width} height={height} {...colorProps} {...rest} />;
}

export default Illustration;
